/**
 * Page Module Routes
 * 
 * Rutas para el módulo de páginas (templates V2)
 */

import isAuthenticatedGuard from "@/pages/Auth/guards/is-authenticated.guard";

const pageModuleRoutes = [
  {
    path: "pages/:type/:id",
    name: "PageTemplate",
    component: () => import("@/modules/page_module/components/PageTemplate.vue"),
    beforeEnter: isAuthenticatedGuard,
    meta: { title: "Page View" },
  },
];

export default pageModuleRoutes;

